import { useState as a, useCallback as d, useEffect as c } from "react";
function h(e, t) {
  return e.defaultProps = t, e;
}
function o() {
  let e;
  if (typeof self < "u" && (e = self), typeof window < "u" && (e = window), typeof global < "u" && (e = global), typeof globalThis < "u" && (e = globalThis), e)
    return e;
  throw new Error("unable to locate global object");
}
function f(e) {
  return o()[e] !== void 0;
}
function s() {
  return f("document") ? document.documentElement.clientWidth ?? Math.max(window.outerWidth, window.screen.availWidth) : 1280;
}
const m = () => o().window.innerWidth - o().document.body.offsetWidth;
function p() {
  const [e, t] = a(s()), n = d(() => {
    t(s());
  }, []);
  return c(() => (t(s()), window.addEventListener("resize", n), () => {
    o().removeEventListener("resize", n);
  }), [n]), e;
}
const w = 1, v = (e, t) => {
  const [n, i] = a(!1);
  return c(() => {
    const u = new IntersectionObserver(
      ([l]) => {
        l.isIntersecting ? i(!0) : i(!1);
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: t ?? w
      }
    ), r = e.current;
    return r && u.observe(e.current), () => {
      r && u.unobserve(r);
    };
  }, [e]), n;
};
export {
  s as a,
  m as b,
  v as e,
  o as g,
  f as h,
  p as u,
  h as w
};
//# sourceMappingURL=useIntersectionObserver-1ee6520e.mjs.map
